import { Typography } from "antd"
export const Title = (props) => <Typography.Title {...props}></Typography.Title>
